<template lang="html">
    <div class="container" id="text-page">
      <h1 class="mb-3 page-title">Preguntas frecuentes de los Afiliados</h1>

      <div class="content" v-html="row"></div>

      <!-- <div class="content">
        <h5>¿Qué tipo de productos puedo vender en Bazaar Flex?</h5>
        <p>
          Puedes vender productos fabricados o producidos en México, que cumplan con normativas legales y no estén prohibidos por nuestras políticas (ej. armas, drogas, pornografía, seres vivos, etc.).
        </p>

        <br />
        <h5>¿Cuánto cobra Bazaar Flex por cada venta?</h5>
        <p>
          La comisión es del 20% del valor total de la venta, descontada al momento de liberar el pago al productor.
        </p>

        <br />
        <h5>¿Cuándo se me paga por una venta realizada?</h5>
        <p>
          El pago se efectúa entre 5 y 10 días hábiles después de que el cliente confirma haber recibido el producto en condiciones adecuadas.
        </p>

        <br />
        <h5>¿Puedo vender productos al extranjero sin tener experiencia en exportación?</h5>
        <p>
          Sí. Te apoyamos con lineamientos básicos de embalaje y envío internacional, aunque eres responsable de cumplir las normas aplicables del país destino.
        </p>

        <br />
        <h5>¿Qué sucede si el cliente devuelve el producto?</h5>
        <p>
          Si el producto fue defectuoso o no cumplió con lo ofrecido, deberás aceptar la devolución y asumir los costos, según la política de la plataforma.
        </p>

        <br>
        <h5>¿Cómo publico mis productos en la plataforma?</h5>
        <p>
          Desde tu cuenta de productor puedes cargar imágenes, descripciones, precios, tiempos de entrega y stock disponible.
        </p>

        <br>
        <h5>¿Puedo ofrecer descuentos o promociones?</h5>
        <p>
          Sí. Puedes establecer precios promocionales y cupones desde tu panel de control.
        </p>

        <br>
        <h5>¿Qué pasa si publico un producto prohibido?</h5>
        <p>
          Tu cuenta será suspendida de forma inmediata y, en caso de gravedad, será notificado a las autoridades correspondientes.
        </p>

        <br>
        <h5>¿Qué pasa si no cumplo con el envío en tiempo y forma?</h5>
        <p>
          Afecta tu reputación dentro del marketplace y puede generar cancelaciones, devoluciones o sanciones administrativas por incumplimiento.
        </p>

        <br>
        <h5>¿Puedo vender productos personalizados o bajo pedido?</h5>
        <p>
          Sí. Debes especificarlo claramente en la descripción del producto, incluyendo los tiempos de producción y entrega.
        </p>
      </div> -->

    </div>
  </template>

  <script>
  export default {
    data(){
      return{
        row:null,
      }
    },

    methods: {
      getData: function(){
        axios.get(tools.url('/api/faqs_users')).then((response)=>{
          this.row = response.data.body;
        }).catch((error)=>{
        })
      },
    },

    mounted(){
        this.getData();
    },
  }
  </script>
